import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    num: Number
  },
  data: function data() {
    return {
      navList: [{
        name: '全部',
        img: require('@/assets/img/icon-topmenu1-w.png'),
        url: '/allModule'
      },
      // {name:'新闻中心',img:require('@/assets/img/icon-topmenu1.png'),url:'/reNews'},
      // {
      //   name: '推荐课程',
      //   img: require('@/assets/img/icon-topmenu3-w.png'),
      //   curImg: require('@/assets/img/icon-topmenu3-w-cur.png'),
      //   url: '/recommendCourse'
      // },
      {
        name: '专业资源库',
        img: require('@/assets/img/icon-topmenu3-w.png'),
        curImg: require('@/assets/img/icon-topmenu3-w-cur.png'),
        url: '/professionalTeaching'
      }, {
        name: '在线精品课',
        img: require('@/assets/img/icon-topmenu4-w.png'),
        curImg: require('@/assets/img/icon-topmenu4-w-cur.png'),
        url: '/boutiqueCourse'
      }, {
        name: '视频公开课',
        img: require('@/assets/img/icon-topmenu5-w.png'),
        curImg: require('@/assets/img/icon-topmenu5-w-cur.png'),
        url: '/virtualCourse'
      }]
    };
  },
  created: function created() {},
  methods: {
    toSecond: function toSecond(url) {
      this.$router.push(url);
    }
  }
};